var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorsedesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 1.75C1.18437 1.75 0.625 2.30937 0.625 3V10.5C0.625 11.1906 1.18437 11.75 1.875 11.75H6.25V13H5V14.25H10V13H8.75V11.75H13.125C13.8156 11.75 14.375 11.1906 14.375 10.5V3C14.375 2.30937 13.8156 1.75 13.125 1.75H1.875ZM1.875 3H13.125V10.5H1.875V3Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorsedesktop);
export default __webpack_public_path__ + "static/media/corsedesktop.3c09f1eead3f82e3ca27891aa6b136ee.svg";
export { ForwardRef as ReactComponent };